export default "__VITE_ASSET__CDLbFTOH__"